var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-field" },
    [
      _c(
        "el-badge",
        {
          staticClass: "label",
          attrs: { value: "error", hidden: !_vm.missing },
        },
        [_c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])]
      ),
      _vm._v(" "),
      _c("el-time-picker", {
        staticStyle: { "max-width": "40%" },
        attrs: {
          placeholder: "Start time",
          size: "medium",
          format: "HH:mm A",
          "picker-options": { format: "HH:mm A" },
          disabled: !_vm.isAdmin,
        },
        on: {
          change: function ($event) {
            return _vm.update(_vm.startTime)
          },
        },
        model: {
          value: _vm.startTime,
          callback: function ($$v) {
            _vm.startTime = $$v
          },
          expression: "startTime",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "date-range__to-label" }, [_vm._v("To")]),
      _vm._v(" "),
      _c("el-time-picker", {
        staticStyle: { "max-width": "40%" },
        attrs: {
          placeholder: "End time",
          size: "medium",
          format: "HH:mm A",
          "picker-options": { format: "HH:mm A", minTime: _vm.startTime },
          disabled: !_vm.isAdmin,
        },
        on: {
          change: function ($event) {
            return _vm.update(_vm.endTime)
          },
        },
        model: {
          value: _vm.endTime,
          callback: function ($$v) {
            _vm.endTime = $$v
          },
          expression: "endTime",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }